<template>
<v-app :dark="darktheme">

  <v-navigation-drawer :disable-resize-watcher=true v-model="menuVisible" temporary fixed app>
    <v-list dense>

      <v-list-tile @click="apps()">
        <v-list-tile-action>
          <v-icon>dashboard</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Apps</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-group prepend-icon="account_circle" v-if="$can('is', 'admin')">
        <v-list-tile slot="activator">
          <v-list-tile-title>Administration</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-for="(admin, i) in admins" :key="i" @click="navipage(admin[2])">
          <v-list-tile-title v-text="admin[0]"></v-list-tile-title>
          <v-list-tile-action>
            <v-icon v-text="admin[1]"></v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>

      <v-list-group prepend-icon="view_list" v-if="$can('view', 'reports') || $can('is', 'admin')">
        <v-list-tile slot="activator">
          <v-list-tile-title>Reporting</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-for="(report, i) in reports" :key="i" @click="navipage(report[2])">
          <v-list-tile-title v-text="report[0]"></v-list-tile-title>
          <v-list-tile-action>
            <v-icon v-text="report[1]"></v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>

      <v-list-group prepend-icon="remove_red_eye" v-if="($can('view', 'payroll') || $can('is', 'admin'))">
        <v-list-tile slot="activator">
          <v-list-tile-title>Screeners</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-for="(screener, i) in screeners" :key="i" @click="navipage(screener[2])">
          <v-list-tile-title v-text="screener[0]"></v-list-tile-title>
          <v-list-tile-action>
            <v-icon v-text="screener[1]"></v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>

      <v-list-tile @click="logout()">
        <v-list-tile-action>
          <v-icon>delete</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>

  <v-toolbar app fixed color="primary" dark>
    <v-toolbar-side-icon v-if="loggedin" @click.stop="toggleMenu()"></v-toolbar-side-icon>
    <v-toolbar-title color="white">VSS</v-toolbar-title>
  </v-toolbar>

  <v-content>
    <v-container fluid fill-height>
      <transition name="slide-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-container>
  </v-content>

  <v-footer class="pa-3">

    <i class="far fa-moon" v-if="!darktheme" @click="darktheme = true"></i>
    <i class="fas fa-moon" v-else @click="darktheme = false"></i>

    <v-spacer></v-spacer>

    <div>VSS Panel v{{version}}&copy; Maxis Systems Inc. {{ new Date().getFullYear() }} &nbsp</div>

    <i class="fas fa-plug" v-if="wsconnected" style="color:green"></i>
    <i class="fas fa-plug" v-else style="color:red"></i>
  </v-footer>

  <v-snackbar v-model="snackbar" :color="color" :multi-line="mode === 'multi-line'" :timeout="timeout" :vertical="mode === 'vertical'">
    {{ text }}
    <v-btn dark flat @click="snackbar = false">
      Close
    </v-btn>
  </v-snackbar>

</v-app>
</template>

<script>
import jwt from 'jsonwebtoken'
import {
  unpackRules
} from '@casl/ability/extra'

import packageJson from '../package'

export default {
  name: 'PersistentFull',
  data: () => ({
    darktheme: true,
    menuVisible: false,
    snackbar: false,
    color: ' ',
    mode: '',
    timeout: 4000,
    text: 'Hello, I\'m a snackbar',
    admins: [
      ['Overview', 'remove_red_eye', 'Overview'],
      ['Live Stats', 'show_chart', 'LiveStats'],
      ['Manage People', 'people_outline', 'ManageUsers'],
      ['Settings', 'settings', 'Settings'],
      ['Downloads', 'arrow_downward', 'Downloads']
    ],
    reports: [
      ['Dashboard', 'reorder', 'Dashboard'],
    ],
    screeners: [
      ['Payroll', 'attach_money', 'Overview']
    ],
    // reports: [
    //   ['Production', 'insert_drive_file', 'Overview']
    // ]
  }),
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    logout() {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'AppLogin'
      })
      this.$store.dispatch('LOGOUT')
      this.menuVisible = false
      this.$ability.update({})
    },
    apps() {
      this.$router.push({
        name: 'MainPage'
      })
    },
    admin() {
      this.$router.push({
        name: 'Admin'
      })
    },
    navipage(page) {
      this.$router.push({
        name: page
      })
    }
  },
  computed: {
    loggedin: function() {
      return this.$store.getters.loggedin
    },
    wsconnected: function() {
      return this.$store.getters.wsconnected
    },
    version: function() {
      return packageJson.version;
    }

  },
  beforeMount: function() {
    if (localStorage.getItem('darktheme') !== null) {
      var isDark = localStorage.getItem('darktheme');

      this.darktheme = (isDark === 'true');
      this.$store.state.darktheme = this.darktheme;
    } else {
      localStorage.setItem('darktheme', this.darktheme);
      this.$store.state.darktheme = this.darktheme;
    }

    if (localStorage.getItem('jwtToken')) {
      var token = localStorage.getItem('jwtToken')

      var decoded = jwt.decode(String(token).split(' ')[1])

      this.processRules(decoded.rules);

      this.$router.push({
        name: 'MainPage'
      })
    }
  },
  mounted: function() {
    console.log("CHECK IF SESSION EXPIRE HERE");

    if (localStorage.getItem('jwtToken')) {

      var token = localStorage.getItem('jwtToken')

      var decoded = jwt.decode(String(token).split(' ')[1])

      console.log(decoded)

      var current_time = new Date().getTime() / 1000;

      var jwtexp = decoded.exp;

      if (current_time > jwtexp) {
        this.text = "Your session has expired. Please login again!"
        this.snackbar = true
        this.color = 'red'

        this.logout();
      }
    }else{
      this.logout();
    }


    this.$root.$on('snackbar', message => {
      this.text = message
      this.snackbar = true
      this.color = 'red'
    })
  },
  watch: {
    darktheme: function(after, before) {
      localStorage.setItem('darktheme', after);
      this.$store.state.darktheme = after;
    }
  }
}
</script>

<style lang="scss" scoped>
.md-app {
    min-height: 350px;
    border: 1px solid rgba(#000, .12);
}

// Demo purposes only
.md-drawer {
    width: 200px;
    max-width: calc(100vw - 125px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue